export const vns = {
    listagem: {
        titulo_pagina: 'VNS\'s List',
        novo: 'Create New VNS',
        table: {
            empty: "No VNS Found",
            habilitado: 'Able',
            desabilitado: 'Disabled',
            nome: 'Name',
            empresa: 'Company',
            integracao_origem: 'Origin Integration',
            integracao_destino: 'Destination Integration',
            modem: {
                label: 'Modem',
                serial: 'Serial',
                empresa: 'Company',
                chip: 'Chip',
                limit: 'Limit',
                alerta: 'Alert',
                consumo: 'Consumption',
            },
            numero_gps: 'Number',
            sensor_temperatura: 'Temperature Sensor',
            estado: 'State',
            monitor: 'Monitor',
            acoes: 'Actions',
            editar: 'Edit'
        }
    },
    permissoes: {
        index: {
            nome: 'Name',
            acoes: 'Actions'
        },
        form: {
            titulo_pagina: 'Edit Permissions',
            botao_salvar: 'Save Permissions',
            update: {
                success: "Permissions Successfully Updated!",
                error: "Error Updating Permissions!"
            }
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New VNS',
            editar: 'Edit VNS'
        },
        create:{
            success: 'VNS Created Successfully',
            error: 'Error Creating VNS!'
        },
        update:{
            success: 'VNS Updated Successfully',
            error: 'Error Updating VNS'
        },
        fieldsets: {
            informacoes: 'Information',
            integracoes: 'Integrations',
            perifericos: 'Peripherals'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'VNS Name'
            },
            empresa: {
                label: 'Company',
                description: 'Company to Which the VNS Belongs'
            },
            unidade: {
                label: 'Unit',
                description: 'Company Service Unit'
            },
            setor: {
                label: 'Sector',
                description: 'Sector of the unit care'
            },
            estado: {
                label: 'State',
                description: 'State the VNS is In'
            },
            integracao_origem: {
                label: 'Origin Integration',
                description: 'What is the Origin of Integration?'
            },
            credencial_origem: {
                label: 'Origin Credential',
                description: 'Integration Origin Credential'
            },
            integracao_destino: {
                label: 'Destination Integration',
                description: 'What is the purpose of the integration'
            },
            credencial_destino: {
                label: 'Destination Credential',
                description: 'Integration Destination Credential'
            },
            integracao_impressao: {
                label: 'Print Integration',
                description: 'What is Print Integration'
            },
            credencial_impressao: {
                label: 'Print Credential',
                description: 'Print Credential'
            },
            atributos: {
                label: 'Attributes',
                description: 'Attributes Used for Integration'
            },
            modem: {
                label: 'Modem',
                description: 'VNS Modem Status (Active or Inactive)',
                dados: 'Modem Information',
                serial: {
                    label: 'Serial',
                    description: 'VNS Modem Serial'
                },
                numero_chip: {
                    label: 'Number',
                    description: 'Modem Chip Number'
                },
                empresa: {
                    label: 'Company',
                    description: 'Modem Company'
                },
                data_limit: {
                    label: 'Data Limit',
                    description: 'Modem Data Limit'
                },
                data_alert: {
                    label: 'Data Alert',
                    description: 'Modem alert data number'
                },
                data_consumption: {
                    label: 'Consumption',
                    description: 'Modem Consumption'
                }
            },
            gps: {
                label: 'GPS',
                description: 'VNS GPS Status (active or inactive)',
                numero: {
                    label: 'Number',
                    description: 'GPS Number'
                }
            },
            sensor_temperatura: {
                label: 'Temperature',
                description: 'VNS Temperature Sensor Status (Active or Inactive)'
            },
            status: {
                label: 'Status',
                description: 'VNS status (active or inactive)'
            },
            monitor: {
                label: 'Monitor',
                description: 'Show in VNS Monitor (active or inactive)'
            },
            botao_salvar: 'Save VNS'
        }
    },
    ranges: {
        listagem: {
            novo: 'Create New Range',
            table: {
                empty: "No Range Found",
                editar: "Edit",
                valor_inicial: 'Initial Value',
                valor_final: 'Final Value',
                fundo: "Background Color",
                letra: "Font Color"
            }
        },
        form: {
            titulo_pagina: {
                criar: 'Create New Range',
                editar: 'Edit Range'
            },
            fields: {
                inicio: 'Start of Range',
                final: 'End of Range',
                fundo: {
                    label: 'Range Color',
                    description: 'Range Background Color'
                },
                escrita: {
                    label: 'Writing Color',
                    description: 'Range Letter Color'
                },
                botao_salvar : 'Save Range'
            },
            create: {
                success: "Range Created Successfully!",
                error: "Error Creating Range!"
            },
            update: {
                success: "Range Successfully Edited!",
                error: "Error Editing Range!"
            }
        }
    },
}

export const monitoramento = {
    titulo_automacao: 'VNS Automation',
    titulo_display: 'VNS Display',
    titulo_quick: 'VNS Quick',
    titulo_link: 'VNS Link',
    titulo_all: 'VNS listing',
    tipos_integracao: {
        impressora: 'Print',          
        automacao: 'Automation',          
        lis: 'LIS',          
        display: 'Display',         
        generic: 'Generic',          
        quick: 'Quick',          
        his: 'HIS',          
        label: 'Label',          
        temp: 'Temperature',
        indefinido: 'Undefined'
    },
    resumo: {
        tabs: {
            informacoes: {
                title: 'Information',
                list: {
                    tipo: 'Type',
                    integracao: 'Integration',
                    impressora: 'Printer',
                    sensor: 'Temperature Sensor',
                    enviados: 'Sent Data',
                    recebidos: 'Received Data'
                }
            },
            comandos: {
                title: 'Commands',
                versoes: {
                    title: 'Update Version',
                    informe_versao: 'Or Tell the Version',
                    update_button: 'Update',
                    sucesso: 'Command sent successfully!',
                    error: 'Error sending command, check the LOG!'
                },
                atividade: {
                    title: 'Trigger VNS Activity',
                    informe_comando: 'Enter the command',
                    send_button: 'Send Command',
                    sucesso: 'Command Sent Successfully!',
                    error: 'Error sending command, check the LOG!',
                    comando_para_vns: 'Command to VNS'
                }
            },
            latencia: {
                title: 'Latency',
                tabs: {
                    ultimo: 'Last',
                    historico: 'Historic',
                },
                little_cards: {
                    ip_interno: 'Internal IP',
                    ip_externo: 'External IP',
                    ultima_atualizacao: 'Last Update',
                    latencia: 'Average Latency',
                    disco: 'Free Disk',
                    cpu: 'CPU',
                    periodo: 'Period',
                    minutos: 'Minutes',
                    hora: 'Hour',
                    personalizado: 'Custom',
                    cancelar: 'Cancel'
                }
            },
            temperatura: {
                title: 'Temperature',
                little_cards: {
                    temperatura: 'Temperature',
                    umidade: 'Moisture'
                }
            },
            localizacao: {
                title: 'Location',
                ultima: 'Last Location',
                nenhuma_localizacao: 'No Location found.',
            },
            log_panel: {
                codigo_erro: 'Error code:',
                vns_equipamento: 'VNS/Equipment',
                tipo: 'Type',
                data_hora: 'Date/Time',
                acao: 'Action',
                ver_log: 'View log',
                alerta_vns: 'VNS Alert'
            },
            jira: {
                title: 'Jira',
                tabela_titulo: {
                    tipo: 'type',
                    status: 'status',
                    data_atualizacao: 'update_date'
                }
            }      
        }
    },
    detalhe:{
        table: {
            consumo_total: 'Total Consumption',
            empresas: 'Companies',
            unidades: 'Units',
            tipo: 'Type',
            equipamento: 'Equipament',
            com_alertas: 'With Alerts',
            empresa: 'Company',
            unidade: 'Unit',
            apelido: 'Nickname',
            ip_interno: 'Internal IP',
            ip_externo: 'External IP',
            latencia: 'Latency',
            impressora: 'Printer',
            recebidos: 'Bytes Received',
            enviados: 'Bytes Sent',
            disco_livre: 'Free Disk',
            vns_detalhados: 'detailed VNS\'s',
            filtro_indisponivel: 'Filter unavailable'
        }
    },
    jira: {
        tipos_problema: {
            ip: 'Comunication Problem',
            temperatura: 'Temperature Problem'
        },
        table: {
            empty: 'No jira found'
        }
    }
}